/// <amd-module name="VSS/Platform/RestClient/ClientTrace" />
/**
 * ---------------------------------------------------------
 * Generated file, DO NOT EDIT
 * ---------------------------------------------------------
 *
 * See following wiki page for instructions on how to regenerate:
 *   https://aka.ms/azure-devops-client-generation
 *
 * Configuration file:
 *   webplatform\web\extensions\vss-web\vss-platform\genclient.json
 */

import { IVssPageContext, IVssRestClientOptions, RestClients } from "../Context";
import { RestClientBase } from "../RestClientBase";

import * as ClientTrace from "../Contracts/ClientTrace";

import { IClientTraceRestClient } from "VSS/Platform/RestClient/ClientTrace.Types";

export { IClientTraceRestClient } from "VSS/Platform/RestClient/ClientTrace.Types";

class ClientTraceRestClient extends RestClientBase implements IClientTraceRestClient {
    constructor(options: IVssRestClientOptions) {
        super(options);
    }

    /**
     * @param events - 
     */
    public async publishEvents(
        events: ClientTrace.ClientTraceEvent[]
        ): Promise<void> {

        return this.beginRequest<void>({
            apiVersion: "4.1-preview.1",
            method: "POST",
            routeTemplate: "_apis/ClientTrace/Events",
            body: events
        });
    }

}

export const ClientTraceClientName = "IClientTraceRestClient";

export function getClientTraceClient(pageContext: IVssPageContext, options?: IVssRestClientOptions): IClientTraceRestClient {
    return pageContext.getRestClient<IClientTraceRestClient>(ClientTraceClientName, options);
}

RestClients.add(ClientTraceClientName, { 
    factory: ClientTraceRestClient
});
